<main class="page-not-found">
    <section class="page-not-found__content" aria-labelledby="page-not-found-title">
        <p class="page-not-found__code">404</p>
        <h1 id="page-not-found-title">{{ "Shared.PAGE_NOT_FOUND" | translate }}</h1>
        <p class="page-not-found__message">{{ "Shared.PAGE_NOT_FOUND_MESSAGE" | translate }}</p>
    </section>
</main>